"use client";

import { useEffect, useRef } from "react";

export default function AboutHeader() {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const els = ref?.current?.querySelectorAll(".reveal");
        if (!els) return;
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("visible");
                        observer.unobserve(e.target);
                    }
                }),
            { threshold: 0.1 }
        );
        els?.forEach((el) => observer?.observe(el));
        return () => observer?.disconnect();
    }, []);

    return (
        <section
            ref={ref}
            className="section-navy-mid"
            style={{ paddingTop: "80px", paddingBottom: "80px" }}
        >
            <div
                className="px-6 lg:px-12"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
            >
                <div className="text-center mb-8 reveal reveal-delay-1">
                    <p className="type-subheading mb-8" style={{ color: "var(--color-red)" }}>PARTNERSHIP FOUNDATION</p>
                    <h2
                        style={{
                            fontFamily: "var(--font-serif)",
                            fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
                            fontWeight: 400,
                            color: "var(--color-white)",
                            lineHeight: 1.15,
                            letterSpacing: "-0.015em",
                        }}
                    >
                        What We Exchange
                    </h2>
                    <p
                        className="reveal reveal-delay-2"
                        style={{
                            fontFamily: "var(--font-sans)",
                            fontSize: "1rem",
                            color: "rgba(255,255,255,0.55)",
                            lineHeight: "1.7",
                            marginTop: "20px",
                            margin: "20px auto 0",
                        }}
                    >
                        Terms already can typically be formulated within two weeks since specifications and commitment availability.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 reveal reveal-delay-2">
                    <div className="card p-8">
                        <h3
                            style={{
                                fontFamily: "var(--font-serif)",
                                fontSize: "1.3125rem",
                                fontWeight: 400,
                                color: "var(--color-white)",
                                lineHeight: 1.2,
                                marginBottom: "16px",
                            }}
                        >
                            From Supplier
                        </h3>
                        <ul
                            style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                            }}
                        >
                            {[
                                "Recent assay data",
                                "Production forecast",
                                "Export documentation",
                                "ESG documentation",
                            ].map((item) => (
                                <li
                                    key={item}
                                    className="type-body mb-3"
                                    style={{
                                        paddingLeft: "24px",
                                        position: "relative",
                                    }}
                                >
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: 0,
                                            color: "var(--color-red)",
                                            fontWeight: 600,
                                        }}
                                    >
                                        •
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="card p-8">
                        <h3
                            style={{
                                fontFamily: "var(--font-serif)",
                                fontSize: "1.3125rem",
                                fontWeight: 400,
                                color: "var(--color-white)",
                                lineHeight: 1.2,
                                marginBottom: "16px",
                            }}
                        >
                            From Refinery
                        </h3>
                        <ul
                            style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                            }}
                        >
                            {[
                                "Acceptance ranges",
                                "Penalty schedule",
                                "Preferred benchmarks",
                                "Payment terms",
                            ].map((item) => (
                                <li
                                    key={item}
                                    className="type-body mb-3"
                                    style={{
                                        paddingLeft: "24px",
                                        position: "relative",
                                    }}
                                >
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: 0,
                                            color: "var(--color-red)",
                                            fontWeight: 600,
                                        }}
                                    >
                                        •
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}